<template>
  <div class="search w-form LkSearchInput">
    <form name="email-form" class="search-inner" @submit.prevent="submit">
      <div class="LkSearchInput__container">
        <input
          v-model="model"
          type="text"
          class="search-input w-input"
          maxlength="256"
          name="search"
          :placeholder="placeholder"
          @input="$emit('input', model)"
        >

        <IconSearch
          :loading="loading"
          class="LkSearchInput__icon-search"
        />

        <IconClose
          v-if="value"
          class="LkSearchInput__icon-close"
          @click.native="onClear"
        />
      </div>

      <input
        type="submit"
        :value="loading ? 'Подождите...' : 'Поиск'"
        class="search-button w-button LkSearchInput__button"
      >
    </form>
  </div>
</template>

<script>
import IconSearch from '@/components/lk/icons/LKIconSearch.vue'
import IconClose from '@/components/lk/icons/LKIconClose.vue'


export default {
  name: 'LkSearchInput',
  components: {
    IconSearch,
    IconClose,
  },
  props: {
    value: String,
    loading: Boolean,
    placeholder: String,
  },
  data: (vm) => ({
    model: vm.value,
  }),
  methods: {
    submit() {
      this.$emit('submit', this.model)
    },
    onClear() {
      this.model = void 0
      this.$emit('input', this.model)
      this.submit()
    },
  },
}
</script>

<style lang="scss">
.LkSearchInput {
  &__container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__button {
    outline-style: none;
  }

  &__icon-search {
    position: absolute;
    left: 24px;
  }

  &__icon-close {
    position: absolute;
    right: 16px;
    opacity: 0.5;
  }
}
</style>
